<template>
  <el-container class="productTask">
    <el-main style="padding: 0">
      <view-table
          ref="viewTable"
          :limits="limits"
          :columns-property="columnsProperty"
          :filter="filter"
          module="basic"
          :table-select="false"
          url="snSerialNos/listSN">
        <template slot="adSearch">
          <div class="vm-search">
            <el-form :inline="true" :model="filter" label-width="90px" @keyup.enter.native="loadData(1)">
              <el-form-item label="条码">
                <el-input v-model.trim="filter.serialNo" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="派工单号">
                <el-input v-model.trim="filter.billNo" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="物料编号">
                <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="物料名称">
                <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
              </el-form-item>
              <el-form-item label="规格型号">
                <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
              </el-form-item>
<!--              <el-form-item label="物料类型">-->
<!--                <el-select v-model="filter.materialTypeId" placeholder="请选择" clearable>-->
<!--                  <el-option-->
<!--                      v-for="item in materialTypeList"-->
<!--                      :key="item.pkid"-->
<!--                      :label="item.materialTypeName"-->
<!--                      :value="item.pkid"/>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
              <el-form-item label="物料类型">
                <el-select
                    v-model="materialTypeList"
                    :popper-append-to-body="false"
                    class="biddingStageSty"
                    multiple
                    clearable
                    placeholder="请选择"
                    @change="handleSelectMaterialType">
                  <el-option v-for="item in materialTypeOptions" :key="item.value" :label="item.name" :value="item.value"/>
                </el-select>
              </el-form-item>
              <el-form-item label="创建时间">
                <el-date-picker
                    v-model="dateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="dateRangeChange('dateRange','startTime','endTime')"/>
              </el-form-item>
              <el-form-item label="创建人">
                <el-input v-model.trim="filter.creatorName" placeholder="请输入" clearable/>
              </el-form-item>
            </el-form>
          </div>
        </template>
      </view-table>
    </el-main>
    <production-order-preview ref="detailPage"/>
  </el-container>
</template>
<script>
  import ProductionOrderPreview from "../ProductionOrder/ProductionOrderPreview.vue";
  import ViewTable from "@/components/ViewTable";

  export default {
    name: "ProductionCodeList",
    components: {
      ViewTable,
      ProductionOrderPreview,
    },
    data() {
      return {
        limits: {
          labelPrintAuth: this.$auth(405),
        },
        loadingPrintCode: false,
        currentRowIndex: "",
        dateRange: [],
        materialTypeList: [],
        materialTypeOptions: [],
        productInfo: {
          feedingStatus: 10,
        },
        searchShow: false,
        finishDateRange: "",
        biddingStage: [],
        filter: {
          billNo: "",
          materialNo: "",
          materialTypeId: "",
          materialTypeIds: "",
          materialName: "",
          specification: "",
          creatorName: "",
          serialNo: "",
          startTime: "",
          endTime: "",
        },
        columnsProperty: [
          // {
          //   key: "billNo",
          //   width: 120,
          //   align: "center",
          //   render: (h, params) => {
          //     return h(
          //         "span",
          //         {
          //           style: {
          //             color: "#2d8cf0",
          //             cursor: "pointer",
          //           },
          //           on: {
          //             click: () => {
          //               this.$refs.detailPage.open(params.row);
          //             },
          //           },
          //         },
          //         params.row.billNo,
          //     );
          //   },
          // },
        ],
      };
    },

    watch: {
      "filter.startTime": {
        handler(newVal) {
          if (newVal) {
            this.dateRange = [];
            this.dateRange.push(this.filter.startTime);
            this.dateRange.push(this.filter.endTime);
          }
        },
      },
      "filter.materialTypeIds": {
        handler(val) {
          if (val) {
            this.materialTypeList = [];
            this.materialTypeOptions.map(item => {
              val.split(",").forEach((s) => {
                if (parseInt(s) === parseInt(item.value)) {
                  this.materialTypeList.push(item.value);
                }
              });
            });
          }
        },
      },
    },

    mounted() {
      this.getMaterialTypeList();
      this.loadData(1);
    },
    methods: {
      getMaterialTypeList() {
        this.materialTypeOptions = [];
        this.$http.get("basic", "materialTypes/getAllList").then((res) => {
          if (res.success) {
            res.data.forEach((item) => {
              let temp = {"name": item.materialTypeName, "value": item.pkid};
              this.materialTypeOptions.push(temp);
            });
          }
        });
      },
      handleSelectMaterialType(value) {
        if (value.length) {
          // this.materialTypeList = value;
          this.filter.materialTypeIds = value.join(",");
        } else {
          // this.materialTypeList = [];
          this.filter.materialTypeIds = "";
        }
      },
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      handleClick() {
        this.dateRange = [];
      },

      rowClick(row) {
        const tableData = this.$refs.vmTable.tableData;
        tableData.forEach((item, index) => {
          if (item.pkid === row.pkid) {
            this.currentRowIndex = index;
            this.productInfo = row;
            this.productionOrderId = row.pkid;
          }
        });
      },

      selectedRow(row, index) {
        this.currentRowIndex = index;
        this.productInfo = row;
        this.productionOrderId = row.pkid;
      },

      setSelectedRow(val) {
        this.rowClick(val);
      },
    },
  };
</script>

<style>
.productTask .el-table__body-wrapper::-webkit-scrollbar {
  width: 16px !important;
  height: 16px !important;
  z-index: 99999;
}

.productTask .el-table__fixed-right-patch {
  width: 16px !important;
}

.productTask .el-table__fixed-right {
  right: 16px !important;
  bottom: 16px !important;
}

.productTask .el-table .el-table__cell {
  padding: 8px 0;
}

.biddingStageSty /deep/ .el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  display: none;
}
</style>
